import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import AlertModal from "../_common/AlertModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import adrActions from "../../_actions/adrActions";

class AdrWorkPerformedTabsV3 extends Component {
  state = {
    showClose: true,
    currMouseOverWpTabId: null,
    wpTabIdToDelete: null,
    showAlert_closeWp: false,
  };

  toggleAlert_close = () =>
    this.setState({ showAlert_closeWp: !this.state.showAlert_closeWp });

  handleClick_select = (wpTabId) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.selectWpTab(wpTabId);
  };

  handleClick_close = (wpTabId) => (e) => {
    const { isReadOnly } = this.props;
    e.preventDefault();
    e.stopPropagation();
    if (!isReadOnly) {
      this.setState({ wpTabIdToDelete: wpTabId });
      this.toggleAlert_close();
    }
  };

  handleClick_addWp = (e) => {
    e.preventDefault();
    this.props.toggleModal_addWp();
  };

  showCloseOnMouseOver = (currMouseOverWpTabId) => () =>
    this.setState({
      showClose: this.props.status.isReadOnly ? false : true,
      currMouseOverWpTabId,
    });

  hideCloseOnMouseOut = () =>
    this.setState({ showClose: false, currMouseOverWpTabId: null });

  handleAlert_close = (actionType) => (e) => {
    const { closeWpTab } = this.props;
    e.preventDefault();
    this.toggleAlert_close();
    if (actionType === "accept") closeWpTab(this.state.wpTabIdToDelete);
  };

  renderWpTab = (wpTabId) => {
    const { status, workPerformedClient: wpc, selectedWpTabId } = this.props;
    const { showClose, currMouseOverWpTabId } = this.state;
    return (
      <li key={wpTabId} className="nav-item">
        <div
          className={`nav-link border border-secondary border-bottom-0 pointer-cursor ${
            wpTabId === selectedWpTabId ? "active tab-border" : ""
          }`}
          onClick={this.handleClick_select(wpTabId)}
          onMouseOver={this.showCloseOnMouseOver(wpTabId)}
          onMouseOut={this.hideCloseOnMouseOut}
          role="tab"
        >
          {wpc[wpTabId].wpShortCaption}{" "}
          <small>{wpc[wpTabId].isIdle ? "(Idle)" : ""}</small>
          <span key="dummySpacer1" className="ml-3" />
          <span key={wpc[wpTabId].workPerformedId}>
            {((!showClose || wpTabId !== currMouseOverWpTabId) &&
              wpTabId !== selectedWpTabId) ||
            status.isReadOnly ? (
              <FontAwesomeIcon
                key={wpc[wpTabId].workPerformedId}
                icon="times"
                className="icon-invisible"
              />
            ) : (
              <FontAwesomeIcon
                key={wpc[wpTabId].workPerformedId}
                icon="times"
                className="mt-1"
                onClick={this.handleClick_close(wpTabId)}
              />
            )}
          </span>
        </div>
      </li>
    );
  };

  renderDefaultTab = () => {
    return (
      <li className="nav-item">
        <a
          href="#wpTab_0"
          className="nav-link active border border-secondary border-bottom-0"
          id="startTab"
          role="tab"
        >
          Start
        </a>
      </li>
    );
  };

  render() {
    const { wpTabIdToDelete, showAlert_closeWp } = this.state;
    const { dispatch, tabId, workPerformedClient: wpc, status } = this.props;
    const wpSortOrder = dispatch(adrActions.getWorkPerformedSortOrder(tabId));
    return (
      <React.Fragment>
        <ul className="nav nav-tabs border-0" role="tablist">
          {wpSortOrder.length > 0
            ? wpSortOrder.map((wpSo) => this.renderWpTab(wpSo.wpTabId))
            : this.renderDefaultTab()}
          <li className="ml-1">
            <div>
              <button
                type="button"
                className="btn btn-add-wp"
                onClick={this.handleClick_addWp}
                disabled={status.isReadOnly}
              >
                <FontAwesomeIcon icon="plus" />
              </button>
            </div>
          </li>
        </ul>
        {showAlert_closeWp && (
          <AlertModal
            alertTitle="Confirm Delete"
            alertTitleClass="bg-warning"
            alertTitleIcon="exclamation-triangle"
            alertText={`Delete all work data (including attachments) related to ${
              wpTabIdToDelete && wpc[wpTabIdToDelete].wpShortCaption
            } in this report?\n(You cannot undo this action.)`}
            acceptCaption="Yes"
            acceptClass="danger"
            provideReject={true}
            rejectCaption="No"
            rejectClass="secondary"
            handleAlertAction={this.handleAlert_close}
            showAlertModal={showAlert_closeWp}
            toggleAlertModal={this.toggleAlert_close}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  workPerformedClient: state.adr.openAdrs[ownProps.tabId]
    ? state.adr.openAdrs[ownProps.tabId].workPerformedClient || null
    : null,
});

AdrWorkPerformedTabsV3.propTypes = {
  tabId: PropTypes.number,
  workPerformedClient: PropTypes.object,
  status: PropTypes.object,
  selectedWpTabId: PropTypes.number, // wpTabId (a nonzero int)
  selectWpTab: PropTypes.func,
  closeWpTab: PropTypes.func,
  toggleModal_addWorkPerformed: PropTypes.func,
};

export default connect(mapStateToProps)(AdrWorkPerformedTabsV3);
